var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticStyle:{"margin":"0","padding":"0"}},[_c('v-container',{staticStyle:{"margin":"0","padding":"0","height":"100%"},attrs:{"fluid":""}},[_c('router-view',{staticStyle:{"overflow":"hidden"}}),_c('footer-page')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }